import React, { useEffect } from "react";
import ReactWizard from "../components/wizard/ReactWizard";
import BasicInfo from "../components/registration/BasicInfo";
import ContactInfo from "../components/registration/ContactInfo";
import style from "../components/registration/Registration-style.module.css";
import { useSelector,useDispatch } from "react-redux";
import { language } from "../stores/slices/languageSlice";
import { resetSmartySteert } from "../stores/slices/smartyStreetSlice";
import { resetRegisterdetails } from "../stores/slices/einSlice";
import { useNavigate } from "react-router-dom";
import { fetchLookUp } from "../stores/slices/lookupSlice";
import FooterLinks from "../components/login/FooterLinks/FooterLinks";
import { resetprivacyPolicycheckbox } from "../stores/slices/registerSlice";
import { getRegistrationTokenPPP } from "../utilities/API/supertokenServices";

const Registration = () => {
 
 let registerButtonEnbleflag = useSelector((state) => state.registerSlice?.registerData?.privacyPolicycheckbox);
  const dispatch =useDispatch()  
  const navigate =useNavigate()
  const selectedLanguage = useSelector(language).Registrations.reactWizard
  let Tabs = [
    // { label: "WHO ARE YOU?", component: <UserType />, isSubTab: false },
    { label:selectedLanguage?.basicinfoLabel, component: <BasicInfo />, isSubTab: false },
    { label: selectedLanguage?.contactInfo, component: <ContactInfo />, isSubTab: false },
  ];
  const cancelFunction=()=>{
    dispatch(resetSmartySteert())
    dispatch(resetRegisterdetails())
    dispatch(resetprivacyPolicycheckbox())
    navigate("/")
  }
  useEffect(()=>{
    dispatch(fetchLookUp('FAF'))
    getRegistrationTokenPPP()
  },[])
  return (
    <div className={style.basic_container}>
      <ReactWizard
        Tabs={Tabs}
        // initialTab={2}
        title={selectedLanguage?.title}
        subTitle={selectedLanguage?.subTatile}
        finishButtonText={selectedLanguage?.finishButton}
        registerButtonEnbleflag={registerButtonEnbleflag}
        cancelFunction={cancelFunction}
      />
      {/* <FooterLinks path="register"/> */}
    </div>
  );
};

export default Registration;
